import React from 'react'
import { MeetingInfo } from '../../../../MeetingInfo/MeetingInfo'
import { MeetingInfoElement, MeetingSummaryElementProps } from '../../../models'
import './EmbeddedComponents.scss'

export const EmbeddedMeetingInfo: React.FC<MeetingSummaryElementProps<MeetingInfoElement>> = () => {
  return (
    <div className='zocks-pl-2.75 my-3 d-flex flex-column zocks-gap-2 embedded-container'>
      <MeetingInfo />
    </div>
  )
}
